module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.5906fb82.ttf";